module.exports = __webpack_public_path__ + "media/Outdoor Basketball.90fe4b45.mp4";